import dayjs from 'dayjs';
import { RightI } from '../../../interfaces/right';
import { DATE_FORMAT_FRONTEND } from '../../../shared/constants';
import './TerritoryRights.scss';

export function TerritoryRights({ rights }: { rights: RightI[] }) {
  if (!rights || rights.length === 0) {
    return null;
  }

  const groupedByRightId = rights.reduce((acc: { [key: number]: RightI[] }, right: RightI) => {
    console.log('right', right);
    if (!acc[right.rightId]) {
      acc[right.rightId] = [];
    }
    acc[right.rightId].push(right);
    return acc;
  }, {});

  const mergedList = Object.values(groupedByRightId).map((group: RightI[]) => {
    if (group.length === 1) {
      return group[0];
    }

    const first = group[0];
    const merged: RightI = { ...first };

    const dateRanges: string[] = [];
    const remarks: string[] = [];

    group.forEach((right) => {
      if (right.availableDateRanges) {
        dateRanges.push(right.availableDateRanges);
      } else if (right.startDate && right.endDate) {
        dateRanges.push(
          `${dayjs(right.startDate).format(DATE_FORMAT_FRONTEND)} - ${dayjs(right.endDate).format(
            DATE_FORMAT_FRONTEND,
          )}`,
        );
      }
      if (right.remarks) {
        remarks.push(right.remarks);
      }
    });
    merged.availableDateRanges = dateRanges.length > 0 ? dateRanges.join(', ') : null;
    merged.remarks = remarks.length > 0 ? remarks.join('; ') : '';
    return merged;
  });
  return (
    <ul className="territory-rights-list">
      {mergedList?.map((right: RightI) => (
        <li className="territory-rights-item" key={right.id}>
          <b className="territory-rights-name">{right.name}: </b>
          {right?.availableDateRanges
            ? right?.availableDateRanges
            : right?.startDate && right?.endDate
            ? `${dayjs(right?.startDate).format(DATE_FORMAT_FRONTEND)} - ${dayjs(right?.endDate).format(
                DATE_FORMAT_FRONTEND,
              )}`
            : '-'}
          {right.remarks && `. Remarks: ${right.remarks}`}
        </li>
      ))}
    </ul>
  );
}
